import React from 'react';
import {Heading, HeadingProps} from 'components/ui/chakra';

interface GradientHeaderProps extends HeadingProps {
	children: React.ReactNode;
}

const GradientHeading = ({children, ...rest}: GradientHeaderProps) => (
	<Heading
		bgGradient='to-r'
		gradientFrom='clay.600'
		gradientTo='blue.600'
		backgroundClip='text'
		color='transparent'
		fontFamily='heading'
		fontSize={{base: '3xl', md: '4xl'}}
		fontWeight='600'
		letterSpacing='-0.03em'
		lineHeight='1.15'
		pb='0.08em'
		{...rest}
	>
		{children}
	</Heading>
);

export default GradientHeading;
